import Button from '~/components/Button';

interface Props {
  value: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: (v: string) => void;
}

export const SelectButton: React.FC<Props> = ({
  value,
  isSelected,
  isDisabled,
  onSelect,
}) => {
  return (
    <Button
      borderRadius="full"
      backgroundColor={isSelected ? 'secondary.500' : ''}
      variant={isSelected ? 'solid' : 'outline'}
      color={isSelected ? 'white' : 'primary.700'}
      borderColor={!isDisabled ? 'primary.700' : ''}
      height={8}
      onClick={() => onSelect(value)}
      _hover={{
        backgroundColor: isSelected ? 'secondary.600' : 'primary.200',
      }}
      _pressed={{
        backgroundColor: isSelected ? 'secondary.700' : 'primary.200',
      }}
      _focus={{
        backgroundColor: isSelected ? 'secondary.500' : 'primary.200',
      }}
      _focusVisible={{
        backgroundColor: isSelected ? 'secondary.600' : 'primary.200',
      }}
      isDisabled={isDisabled}
    >
      {value}
    </Button>
  );
};
